/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_EditsInputs */

const en_save_edits = /** @type {(inputs: Save_EditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Edits`)
};

const es_save_edits = /** @type {(inputs: Save_EditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar Cambios`)
};

const fr_save_edits = /** @type {(inputs: Save_EditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les modifications`)
};

const de_save_edits = /** @type {(inputs: Save_EditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen speichern`)
};

const ja_save_edits = /** @type {(inputs: Save_EditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編集を保存`)
};

const zh_save_edits = /** @type {(inputs: Save_EditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存编辑`)
};

const ar_save_edits = /** @type {(inputs: Save_EditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حفظ التعديلات`)
};

const id_save_edits = /** @type {(inputs: Save_EditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simpan Editan`)
};

const it_save_edits = /** @type {(inputs: Save_EditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva Modifiche`)
};

const ru_save_edits = /** @type {(inputs: Save_EditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить Изменения`)
};

const pt_save_edits = /** @type {(inputs: Save_EditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar Edições`)
};

const ko_save_edits = /** @type {(inputs: Save_EditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`편집 저장`)
};

/**
* | output |
* | --- |
* | "Save Edits" |
*
* @param {Save_EditsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const save_edits = /** @type {((inputs?: Save_EditsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_EditsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_save_edits(inputs)
	if (locale === "es") return es_save_edits(inputs)
	if (locale === "fr") return fr_save_edits(inputs)
	if (locale === "de") return de_save_edits(inputs)
	if (locale === "ja") return ja_save_edits(inputs)
	if (locale === "zh") return zh_save_edits(inputs)
	if (locale === "ar") return ar_save_edits(inputs)
	if (locale === "id") return id_save_edits(inputs)
	if (locale === "it") return it_save_edits(inputs)
	if (locale === "ru") return ru_save_edits(inputs)
	if (locale === "pt") return pt_save_edits(inputs)
	return ko_save_edits(inputs)
});